import { render, staticRenderFns } from "./Node.vue?vue&type=template&id=b2c77152&"
import script from "./Node.vue?vue&type=script&lang=ts&setup=true&"
export * from "./Node.vue?vue&type=script&lang=ts&setup=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports